// extracted by mini-css-extract-plugin
export default {"wrap":"General_wrap__RGjYS","item":"General_item__PajDd","input":"General_input__k797K","item-delete":"General_item-delete__fM9+8"};